import { buildExportHtml } from '../../components/Download/Download';
import { Status } from '../../types';
import { getEnabledSubsections, getOverviewStatus } from '../../utils/config-utils';
import type { ModerationPreview } from './service';

export const buildModerationPreview = ({ formConfig, formData }: ModerationPreview) => {
  const answers = { ...formData.answers };
  const approvedQuarters = new Set<string>();
  Object.values(formData.approvals || {}).forEach((approval) => {
    if (!approval.approved_at || approval.year !== answers['report-period']) return;
    Object.assign(answers, approval.answers || {});
    if (approval.quarter) approvedQuarters.add(approval.quarter.toLowerCase());
  });
  const sections = formConfig.sections.map((section) => ({
    ...section,
    availableFrom: undefined,
    subsections: section.subsections.map((subsection) => ({
      ...subsection,
      pages: subsection.pages
        .filter(
          (page) => !page.name.startsWith('approval-') || approvedQuarters.has(page.name.slice(-2)),
        )
        .map((page) =>
          page.name.startsWith('approval-') ? { ...page, disabled: undefined } : page,
        ),
    })),
  }));
  const data = { ...formData, answers };
  const config = { ...formConfig, sections };
  const enabled = getEnabledSubsections(config, data);
  const statuses = getOverviewStatus(sections, enabled, data);
  const completedSections = sections.filter((section) =>
    section.subsections.every(
      (subsection) => subsection.pages.length > 0 && statuses[subsection.slug] === Status.Completed,
    ),
  );
  return buildExportHtml(
    'scs',
    formConfig.title,
    undefined,
    completedSections,
    answers,
    data.drafts || {},
    enabled,
    data.formId,
  ).replace('Copy of Submitted Form', 'Completed sections so far');
};
